// src/components/MyPageModal.jsx
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { User } from 'lucide-react'
import { supabase } from '../supabaseClient'

export function MyPageModal({ userId, currentNickname, onClose, onSaved }) {
  const [nickname, setNickname] = useState(currentNickname ?? '')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [saved, setSaved] = useState(false)

  const trimmed = nickname.trim()
  const isValid = trimmed.length >= 2 && trimmed.length <= 20
  const isChanged = trimmed !== (currentNickname ?? '')

  const handleSave = async () => {
    if (!isValid || !isChanged) return
    setLoading(true)
    setError('')

    const { error: dbError } = await supabase
      .from('profiles')
      .update({ nickname: trimmed })
      .eq('user_id', userId)

    if (dbError) {
      setError('保存に失敗しました。もう一度お試しください。')
      setLoading(false)
      return
    }

    setSaved(true)
    setLoading(false)
    onSaved(trimmed)
  }

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9000,
        padding: '16px',
        boxSizing: 'border-box',
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '28px 24px',
        width: '100%',
        maxWidth: 400,
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        boxSizing: 'border-box',
      }}>
        {/* ヘッダー */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <div style={{
            width: 36, height: 36,
            background: 'linear-gradient(135deg, #9333ea, #ec4899)',
            borderRadius: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <User size={18} color="#fff" />
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>
            マイページ
          </h2>
        </div>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 28 }}>
          Howtoon内で表示される名前を変更できます
        </p>

        {/* ニックネーム入力 */}
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
          ニックネーム（2〜20文字）
        </label>
        <div style={{ position: 'relative', marginBottom: 8 }}>
          <input
            type="text"
            value={nickname}
            onChange={e => { setNickname(e.target.value); setSaved(false) }}
            onKeyDown={e => e.key === 'Enter' && handleSave()}
            placeholder="ニックネームを入力"
            maxLength={20}
            autoFocus
            style={{
              width: '100%',
              padding: '12px 48px 12px 14px',
              border: '1.5px solid #e5e7eb',
              borderRadius: 10,
              fontSize: 15,
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border-color 0.15s',
            }}
            onFocus={e => { e.target.style.borderColor = '#9333ea' }}
            onBlur={e => { e.target.style.borderColor = '#e5e7eb' }}
          />
          <span style={{
            position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
            fontSize: 11, color: trimmed.length > 20 ? '#ef4444' : '#9ca3af',
          }}>
            {trimmed.length}/20
          </span>
        </div>

        {error && (
          <p style={{ fontSize: 12, color: '#ef4444', margin: '0 0 12px' }}>{error}</p>
        )}
        {saved && (
          <p style={{ fontSize: 12, color: '#10b981', margin: '0 0 12px' }}>保存しました！</p>
        )}

        {/* ボタン */}
        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '11px 0',
              background: '#f3f4f6',
              border: 'none',
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 600,
              color: '#6b7280',
              cursor: 'pointer',
            }}
          >
            閉じる
          </button>
          <button
            onClick={handleSave}
            disabled={!isValid || !isChanged || loading}
            style={{
              flex: 1,
              padding: '11px 0',
              background: isValid && isChanged && !loading
                ? 'linear-gradient(135deg, #9333ea, #ec4899)'
                : '#e5e7eb',
              border: 'none',
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 600,
              color: isValid && isChanged && !loading ? '#fff' : '#9ca3af',
              cursor: isValid && isChanged && !loading ? 'pointer' : 'not-allowed',
              transition: 'background 0.2s',
            }}
          >
            {loading ? '保存中...' : '保存する'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
